module.exports = __webpack_public_path__ + "img/misson.5ba8723e.svg";